import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-commonlayout',
  templateUrl: './commonlayout.component.html',
  styleUrls: ['./commonlayout.component.scss']
})
export class CommonlayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
